import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "src/app/shared/auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private defaultLan = this.authService.getCurrentUserInfo()?.lang ?? 'zh-TW';
  private langs = [
    { code: 'en', text: 'English' },
    { code: 'zh-CN', text: '简体中文' },
    { code: 'zh-TW', text: '繁體中文' },
  ];
  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
  ) {
    const lansArr = this.langs.map(item => item.code);
    translateService.addLangs(lansArr);
    translateService.setDefaultLang(this.defaultLan);
  }

  changeLang(lang: string) {
    let userLang = this.defaultLan;
    for (const row of this.langs) {
      if (row.code === lang) {
        userLang = lang;
        break;
      }
    }
    this.translateService.use(userLang);


  }
}
